import { useQuery } from '@tanstack/react-query'
import { fetchSignedDownloadURL } from '../api'

type UseDocumentLinkArgs = {
  s3PrivateURL?: string
}

export default function useDocumentURL({ s3PrivateURL }: UseDocumentLinkArgs) {
  const {
    data: documentURL,
    error,
    isLoading
  } = useQuery<string, Error>({
    queryKey: ['DocumentLink', s3PrivateURL],
    queryFn: async () => {
      if (s3PrivateURL) {
        const fileKey = new URL(s3PrivateURL).pathname.replace(/^\//, '')

        const response = await fetchSignedDownloadURL(fileKey)
        return response.signed_url
      }

      throw new Error('No URL provided to download document')
    },
    enabled: !!s3PrivateURL
  })

  return {
    documentURL,
    error,
    isLoading
  }
}
